<template>
  <div>
        <h2 >Neurological Examination</h2>
    <v-container v-if="!loading" class="py-10">
        <v-row>
            <v-col v-for="item in neuro" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
                <v-checkbox
                        v-model="neuroCheckbox"
                        :rules="[v => !!v || 'Neuro is required']"
                        required
                        :disabled="disableNeuro(item.id, item.is_normal)"
                        :label='item.name'
                        :value="item.id"
                        hide-details
                        @change="toggle => neuroTick(item.id, toggle, item.is_normal)"
                />

            </v-col>
        </v-row>
        <v-row v-if="isNeuroRemark">
            <v-col>
                <v-text-field
                        placeholder="Other"
                        outlined
                        v-model="neuro_remark"
                        :rules="[v => !!v || 'Neuro Other is required']"
                        label="Neuro Other"
                        @keyup="includeNeuroRemark"
                        required
                />
            </v-col>
        </v-row>
    </v-container>

    <v-container v-else style="text-align: center;">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>

  </div>
</template>

<script>
    export default {
        name: "Neuro",

        props: {
            formData: {
                type: Object,
                required: true,
            },
            config: Number
        },

        data() {
            return {
                neuroError: false,
                isNeuroRemark: false,
                neuro_remark: null,
                isNeuroNormal: false,
                neuro: {},
                neuroCheckbox: [],
                loading: true
            }
        },

        methods: {
            editFieldNeuro() {
                let vm = this;
                _.forEach(this.formData.physical_examination.neuro, function(value) {
                    vm.neuroCheckbox.push(Number.parseInt(value.neuro_id));
                    if (value.neuro_remark) {
                        vm.neuro_remark = value.neuro_remark;
                        vm.isNeuroRemark = true;
                    }
                });
            },

            disableNeuro(id, normal = 0, toggle = true) {
                let vm = this;
                _.forEach(this.formData.physical_examination.neuro, function (value) {
                    if (Number.parseInt(value.neuro_id) === Number.parseInt(id) && normal && toggle) {
                        vm.isNeuroNormal = true;
                    }
                });
                return this.neuroCheckbox.indexOf(id) === -1 && this.isNeuroNormal;
            },

            neuroTick(key, toggle, is_normal) {
                let toggled = toggle.includes(key);
                let neuro = this.formData.physical_examination.neuro;

                if (key === this.config) {
                    this.isNeuroRemark = !this.isNeuroRemark;
                }
                if (is_normal) {
                    this.isNeuroNormal = !this.isNeuroNormal;
                    this.neuroNormalOnly(key, toggled);
                    this.disableNeuro(key, is_normal, toggled);
                }

                if (toggled) {
                    neuro.push({
                        neuro_id: key,
                        neuro_remark: null,
                    });
                } else {
                    let index = neuro.findIndex(neuro => neuro.neuro_id === key);
                    neuro.splice(index, 1);
                }
            },

            neuroNormalOnly(key, toggled) {
                if (toggled){
                    let neuro = this.formData.physical_examination.neuro;
                    neuro.push({
                        neuro_id: key,
                        neuro_remark: null,
                    });
                    this.neuroCheckbox = [key];
                    neuro.splice(0, neuro.length);
                    this.isNeuroRemark = false;
                }
            },

            includeNeuroRemark() {
                let neuro = this.formData.physical_examination.neuro;
                let index = neuro.findIndex(neuro => neuro.neuro_id === this.config);
                neuro.splice(index, 1);
                neuro.push({
                    neuro_id: this.config,
                    neuro_remark: this.neuro_remark,
                });
            },

            getNeuroLib() {
                this.axios.get('neuro-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.neuro = response.data;
                    this.loading = false;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },
        },

        mounted() {
            this.getNeuroLib();
            this.editFieldNeuro();
        }
    }
</script>

<style scoped>

</style>